import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PopoverController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-event-popover',
  templateUrl: './event-popover.page.html',
  styleUrls: ['./event-popover.page.scss'],
})
export class EventPopoverPage implements OnInit {
  s3_url: string = environment.s3_bucket_url;

  @Input() eventDetails: any;

  profilePlaceholder: string = '/assets/images/profile-placeholder.png';

  accountTypeId: number = null;
  slug: string = '';
  userId: string = null;

  profileImage: string = null;
  eventTitle: string = '';
  eventDate: string = '';
  eventStartTime: string = '';
  eventEndTime: string = '';
  time: string = '';
  eventDescription: string = '';
  fullName: string = '';
  whereEvent: string = '';
  eventAddress: string = '';
  eventDistance: string = '';
  eventLat: string = '';
  eventLong: string = '';

  constructor(
    public router: Router,
    private popover: PopoverController
  ) {}

  ngOnInit() {
    this.setPopoverData();
  }

  setPopoverData() {
    this.accountTypeId = this.eventDetails.user.account_type.id;
    this.userId = this.eventDetails.user_id;

    // console.log('event details are here ---> ', this.eventDetails);

    this.profileImage =
      this.eventDetails.user.user_account_information?.profile_image;
    this.eventTitle = this.eventDetails.event_title;
    this.eventDate = moment(this.eventDetails.event_date).format('MMMM D, YYYY');
    if (
      this.eventDetails.event_start_time !== null &&
      this.eventDetails.event_end_time !== null
    ) {
      this.eventStartTime = moment(this.eventDetails.event_start_time, "HH:mm:ss").format('hh:mm A');
      this.eventEndTime = moment(this.eventDetails.event_end_time, "HH:mm:ss").format('hh:mm A');
      this.time = this.eventStartTime + ' - ' + this.eventEndTime;
    } else {
      this.time = 'All Day';
    }
    this.eventDescription = this.eventDetails.event_description;
    this.fullName =
      this.eventDetails.user.first_name +
      ' ' +
      this.eventDetails.user.last_name;
    this.whereEvent = this.eventDetails.where_event;
    this.eventAddress = this.eventDetails.event_address;
    this.eventDistance = this.eventDetails.distance;
    this.eventLat = this.eventDetails.lat;
    this.eventLong = this.eventDetails.long;
  }

  getSlug(account_type) {
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';
    return type;
  }

  async goToProfile(userId) {
    const loggedInId = JSON.parse(localStorage.getItem('user_profile')) ? JSON.parse(localStorage.getItem('user_profile')).id : '';
    if(userId == loggedInId)
      this.router.navigate(['profile']);
    else{
      let slug = this.getSlug(this.accountTypeId);
      this.router.navigate([slug + '/' + btoa(userId)]);
    }
    await this.popover.dismiss();
  }

  closePopover() {
    this.popover.dismiss();
  }

  copyToClipboard = str => {
    if(!navigator.clipboard){
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      document.getElementById("custom-tooltip").style.display = "inline";
      setTimeout( function() {
        document.getElementById("custom-tooltip").style.display = "none";
      }, 1000);
    }else{
      navigator.clipboard.writeText(str).then(function() {
        document.getElementById("custom-tooltip").style.display = "inline";
        setTimeout( function() {
          document.getElementById("custom-tooltip").style.display = "none";
        }, 1000);
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }
}
